import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

export interface AIChatConfirmationMessageActionsProps {
  className?: string;
  /** The action buttons. `<Button variant="soft" color="ai">` matches the bubble. */
  children?: ReactNode;
}

/**
 * `AIChatConfirmationMessage`'s footer while a confirmation is still pending -- a row the consumer
 * fills with their own `Button`s, since which actions a confirmation offers is the consumer's
 * call. Use `<Button variant="soft" color="ai">` for buttons styled to match the bubble.
 */
export const AIChatConfirmationMessageActions = ({ className, children }: AIChatConfirmationMessageActionsProps) => (
  <div data-slot="ai-chat-confirmation-actions" className={cn("mt-1 flex items-center gap-2", className)}>
    {children}
  </div>
);
